import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import { MultiBuyerEntityListResponseDto } from './dtos/user-company.dto';
import { MultiBuyerEntityMapper } from './mappers/multi-buyer-entity.mapper';
import { MultiBuyerEntity } from '../models/multi-buyer-entity.model';

const MB_MANAGER_ROLE = 'mbManager';

@Injectable({ providedIn: 'root' })
export class UserMultiBuyerEntityApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;
  private readonly _mapper = new MultiBuyerEntityMapper();

  public entities(companyId: number): Observable<MultiBuyerEntity[]> {
    return this._httpClient
      .get<MultiBuyerEntityListResponseDto>(
        `${this._baseUrl}/companies/v2/getMultiBuyerCompanies/${companyId}`,
        {
          params: new HttpParams().set('userRole', MB_MANAGER_ROLE),
          context: withLoading('content'),
        },
      )
      .pipe(map((response) => this._mapper.fromDtoList(response.buyersCmps)));
  }
}
